"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageCropper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _ZoomIn = _interopRequireDefault(require("@material-ui/icons/ZoomIn"));
var _ZoomOut = _interopRequireDefault(require("@material-ui/icons/ZoomOut"));
var _ZoomOutMap = _interopRequireDefault(require("@material-ui/icons/ZoomOutMap"));
var _Rotate90DegreesCcw = _interopRequireDefault(require("@material-ui/icons/Rotate90DegreesCcw"));
var _DoneOutlineOutlined = _interopRequireDefault(require("@material-ui/icons/DoneOutlineOutlined"));
var _CancelOutlined = _interopRequireDefault(require("@material-ui/icons/CancelOutlined"));
var _reactCropper = _interopRequireDefault(require("react-cropper"));
require("cropperjs/dist/cropper.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * ImageCropper is a component that lets you edit and adjust an image, and crop to a specified aspect ratio.
 * When the user presses the Done or Cancel button, the onDone callback is called with either the image, or null
 * 
 * The caller must pass props:
 *  
 *  image - the original image, as a blob or File blob
 *  aspectRatio (Float) width/height - this is the fixed aspect ratio of the crop window
 *  onDone (Function) called with one argument, the cropped image as an html element (use .toDataURL() to get base64 data).  Null if cancelled
 *  
 * The caller may pass in props:
 * 
 *  doneIconColor: color for the done check icon, default green
 *  cancelIconColor: color for the cancel icon, default red
 * 
 */
var ImageCropper = exports.ImageCropper = /*#__PURE__*/function (_Component) {
  function ImageCropper(props) {
    var _this;
    _classCallCheck(this, ImageCropper);
    _this = _callSuper(this, ImageCropper, [props]);
    _defineProperty(_this, "_buttons", void 0);
    _defineProperty(_this, "_cropper", void 0);
    _defineProperty(_this, "_aspectRatio", void 0);
    _defineProperty(_this, "_onDone", void 0);
    _defineProperty(_this, "_ready", function (event) {
      _this._zoomToFit();
    });
    _defineProperty(_this, "_zoomToFit", function () {
      if (!_this._cropper) return;
      var canvas = _this._cropper.getCanvasData();
      var imgWidth = canvas.naturalWidth;
      var imgHeight = canvas.naturalHeight;
      var zoomScale;
      if (imgWidth > imgHeight) {
        zoomScale = window.innerWidth / imgWidth;
      } else {
        zoomScale = window.innerHeight * 0.75 / imgHeight;
      }
      _this._cropper.zoomTo(zoomScale);
    });
    _this._image = props.image;
    _this._aspectRatio = props.aspectRatio;
    _this._onDone = props.onDone;
    var doneIconColor = props.doneIconColor ? props.doneIconColor : 'green';
    var cancelIconColor = props.cancelIconColor ? props.cancelIconColor : 'red';
    _this._makeButtons(doneIconColor, cancelIconColor);
    return _this;
  }
  _inherits(ImageCropper, _Component);
  return _createClass(ImageCropper, [{
    key: "_makeButtons",
    value: function _makeButtons(doneColor, cancelColor) {
      var _this2 = this;
      this._buttons = [{
        icon: /*#__PURE__*/_react["default"].createElement(_ZoomIn["default"], {
          fontSize: "large"
        }),
        onClick: function onClick() {
          _this2._cropper.zoom(0.1);
        },
        tooltip: "Zoom In"
      }, {
        icon: /*#__PURE__*/_react["default"].createElement(_ZoomOut["default"], {
          fontSize: "large"
        }),
        onClick: function onClick() {
          _this2._cropper.zoom(-0.1);
        },
        tooltip: "Zoom Out"
      }, {
        icon: /*#__PURE__*/_react["default"].createElement(_ZoomOutMap["default"], {
          fontSize: "large"
        }),
        onClick: function onClick() {
          _this2._zoomToFit();
        },
        tooltip: "Zoom to Fit Image"
      }, {
        icon: /*#__PURE__*/_react["default"].createElement(_Rotate90DegreesCcw["default"], {
          fontSize: "large"
        }),
        onClick: function onClick() {
          _this2._cropper.rotate(-90);
        },
        tooltip: "Rotate Counter-clockwise"
      }, {
        icon: /*#__PURE__*/_react["default"].createElement(_Rotate90DegreesCcw["default"], {
          fontSize: "large",
          style: {
            transform: 'scaleX(-1)'
          }
        }),
        onClick: function onClick() {
          _this2._cropper.rotate(90);
        },
        tooltip: "Rotate Clockwise"
      }, {
        icon: /*#__PURE__*/_react["default"].createElement(_DoneOutlineOutlined["default"], {
          fontSize: "large",
          style: {
            marginTop: 10,
            color: doneColor
          }
        }),
        onClick: function onClick() {
          _this2._done();
        },
        tooltip: "Done"
      }, {
        icon: /*#__PURE__*/_react["default"].createElement(_CancelOutlined["default"], {
          fontSize: "large",
          style: {
            color: cancelColor
          }
        }),
        onClick: function onClick() {
          _this2._cancel();
        },
        tooltip: "Cancel"
      }];
    }
  }, {
    key: "_done",
    value: function _done() {
      var croppedImage = this._cropper.getCroppedCanvas();
      this._onDone(croppedImage);
    }
  }, {
    key: "_cancel",
    value: function _cancel() {
      this._onDone(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
        container: true,
        direction: "row",
        spacing: 1
      }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
        item: true,
        md: 11,
        xs: 10
      }, /*#__PURE__*/_react["default"].createElement(_reactCropper["default"], {
        style: {
          height: window.innerHeight * 0.75
        },
        aspectRatio: this._aspectRatio,
        dragMode: "move",
        src: this._image,
        viewMode: 1,
        guides: true,
        background: true,
        responsive: true,
        autoCropArea: 1,
        checkOrientation: false,
        onInitialized: function onInitialized(instance) {
          _this3._cropper = instance;
        },
        ready: this._ready
      })), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
        item: true,
        md: 1,
        xs: 2
      }, /*#__PURE__*/_react["default"].createElement(_core.Paper, null, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
        container: true,
        direction: "column",
        alignContent: "center",
        spacing: 1
      }, this._buttons.map(function (button, index) {
        return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
          item: true,
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
          title: button.tooltip
        }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
          onClick: function onClick() {
            if (_this3._cropper) button.onClick();
          }
        }, button.icon)));
      })))));
    }
  }]);
}(_react.Component);